// extracted by mini-css-extract-plugin
export default {"spin":"loader_spin__P5sGR","loaderContainer":"loader_loaderContainer__DpNeD"};